// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // TOPページの処理
  topBodyBackdropBlur()
}

/**
 * js-topBody にスクロール量に応じた backdrop-filter（blur）を適用する
 * 上端が画面トップに来たとき 0、下端が画面トップに来たとき 10px
 */
function topBodyBackdropBlur() {
  const el = document.querySelector('.js-topBody')
  const MAX_BLUR_PX = 5

  if (!el) {
    return
  }

  let ticking = false
  function applyBlur() {
    const scrollY = window.scrollY || window.pageYOffset
    const rect = el.getBoundingClientRect()
    // 上端がビューポート上に来るスクロール位置 → blur 0
    const scrollStart = scrollY + rect.top
    // 下端がビューポート上に来るスクロール位置 → blur 10
    const scrollEnd = scrollStart + el.offsetHeight - window.innerHeight

    let blur = 0
    if (scrollY <= scrollStart) {
      blur = 0
    } else if (scrollEnd > scrollStart && scrollY >= scrollEnd) {
      blur = MAX_BLUR_PX
    } else if (scrollEnd > scrollStart) {
      const progress = (scrollY - scrollStart) / (scrollEnd - scrollStart)
      blur = progress * MAX_BLUR_PX
    }

    el.style.backdropFilter = `blur(${blur}px)`
    el.style.webkitBackdropFilter = `blur(${blur}px)`
    ticking = false
  }

  function onScroll() {
    if (ticking) return
    ticking = true
    requestAnimationFrame(applyBlur)
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  applyBlur() // 初回
}
